import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RegistrationForm from './components/RegistrationForm';
import AnimatedPhotoWall from './components/AnimatedPhotoWall';
import CaixaHolo from './components/CaixaHolo';
import Main from './components/Main';
import VideoUploadPage from './components/VideoUploadPage';
import TesteCaixa from './components/TesteCaixa';
import PhotoWall from './components/PhotoWall';
import PhrasesCloudSimple from './components/PhrasesCloudSimple';
import QRRegistrationForm from './components/QRRegistrationForm';
import QRViewer from './components/QRViewer';
import CheckinTunel from './components/CheckinTunel';
import CheckinCaixa from './components/CheckinCaixa';
import TwoSectionLayout from './components/TwoSectionLayout';
import PainelPalavras2 from './pages/PainelPalavras2';
import PainelLED from './pages/PainelLED';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/painel_tunel" element={<AnimatedPhotoWall />} />
        <Route path="/photo_wall" element={<PhotoWall />} />
        <Route path="/cadastro" element={<RegistrationForm />} />
        <Route path="/qr_cadastro" element={<QRRegistrationForm />} />
        <Route path="/qr_viewer" element={<QRViewer />} />
        <Route path="/checkin_tunel" element={<CheckinTunel />} />
        <Route path="/checkin_caixa" element={<CheckinCaixa />} />
        <Route path="/caixa_holo" element={<CaixaHolo />} />
        <Route path="/video/upload" element={<VideoUploadPage />} />
        <Route path="/teste_caixa" element={<TesteCaixa />} />
        <Route path="/phrases_cloud" element={<PhrasesCloudSimple />} />
        <Route path="/two_section_layout" element={<TwoSectionLayout />} />
        <Route path="/painel_palavras_2" element={<PainelPalavras2 />} />
        <Route path="/painel_led" element={<PainelLED />} />
      </Routes>
    </Router>
  );
};

export default App;